import { useReactiveVar } from "@apollo/client";
import { Dialog } from "@dmm-com/rocket-web-ui-library";
import { useEffect, useState } from "react";
import type { ErrorCodeType } from "./type";
import { useErrorDialog } from "./use-error-dialog";
import { useRouter } from "next/router";
import { openTextOnlyToast } from "~/components/stores/toast/store";
import { CATEGORY_IDS } from "~/const/categories";
import { PATHS } from "~/const/paths";
import { useIsomorphicEffect } from "~/hooks/use-isomorphic-effect";
import { useQueryString } from "~/hooks/use-query-string";
import { graphQLErrorsVar, networkErrorVar } from "~/lib/apollo/link";
import { Z_INDEX } from "~/styles/z-index";
import { isBot } from "~/util/is-bot";

export const ErrorDialog = () => {
  const graphQLErrors = useReactiveVar(graphQLErrorsVar);
  const networkError = useReactiveVar(networkErrorVar);
  const { replace } = useRouter();
  const { spot: isSpot } = useQueryString();
  const isomorphicEffect = useIsomorphicEffect();
  const { resetError, errorHandling } = useErrorDialog();
  const [isVisible, setIsVisible] = useState(false);

  const code = graphQLErrors && (graphQLErrors[0].extensions.code as ErrorCodeType);
  const existsError = !!graphQLErrors || !!networkError;
  const isStreamError = graphQLErrors && graphQLErrors[0].path?.includes("stream");

  isomorphicEffect(() => {
    // android Chromeのシークレットブラウザのstreamでのエラー個別対応
    if (code === "NOT_FOUND" && isStreamError) {
      resetError();
      return;
    }

    // memo: spotが url query parameterに付与されていた場合、DMMTVスペシャルカテゴリトップに遷移 & 終了トーストを出す
    if (code === "NOT_FOUND" && isSpot) {
      resetError();
      (async () => {
        await replace({ pathname: PATHS.VOD, query: { id: CATEGORY_IDS.SPECIAL } });
        openTextOnlyToast("END_OF_SPOT_LIVE");
      })();
      return;
    }

    if (code === "NOT_FOUND") {
      resetError();
      replace(PATHS["ERROR"]);
    }

    if (code === "MAINTENANCE") {
      resetError();
      replace(PATHS["MAINTENANCE"]);
    }

    setIsVisible(existsError);
  }, [isSpot, code, existsError, isStreamError]);

  useEffect(() => {
    return () => resetError();
  }, []);

  if (!code || isBot()) return null;

  return (
    <Dialog
      title="エラーが発生しました"
      description={`${errorHandling(code).description}`}
      mainButtonName="Close Button"
      mainButtonLabelText="閉じる"
      isCancelButton={false}
      onMainButtonAction={errorHandling(code).action}
      isVisible={isVisible}
      onCloseDialog={errorHandling(code).action}
      zIndex={Z_INDEX.DIALOG}
    />
  );
};
